import { combineReducers, configureStore } from "@reduxjs/toolkit";
import navReducer from "./features/nav/navSlice";
import practiceReducer from "./features/practice/practiceSlice";

const rootReducer = combineReducers({
    nav: navReducer,
    userPractice: practiceReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

// Use for tests
export const setupStore = (preloadedState?: Partial<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
    });
};

// Use everywhere else
export const store = setupStore();

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
